import { render, staticRenderFns } from "./addOrderTagsModal.vue?vue&type=template&id=e8f1f8c2"
import script from "./addOrderTagsModal.vue?vue&type=script&lang=js"
export * from "./addOrderTagsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports